<script>
	import listBase from '@_system/components/base/list.vue'
	import settlementtree from '../lib/datetree/tree.vue'
	import statistics from './lib/statistics/index.vue'
	import reconciliation from './lib/reconciliation/index.vue'
	import directlystockin from './lib/directlystockin/index.vue'
	import editIndex from './lib/edit/index.vue'
	import roundIndex from './lib/round/index.vue'
	export default {
		extends: listBase,
		name: 'purchasestockbillIndex',
		props: {

		},
		render(h) {
			this.$slots.aside = [ <settlementtree ref = "settlementtree"key = {this.settlementtreeKey} defaulttime={this.defaulttime} onSelect = {this.settlementtreeChange}/>
			]
			this.$slots.header = [
				<el-breadcrumb separator-class="el-icon-arrow-right" >
					{
						this.parentbread.length!=0?this.parentbread.map((item,index)=>{
						return <el-breadcrumb-item key={index}>{item.name}</el-breadcrumb-item>
					}):<el-breadcrumb-item>{'采购入库单'}</el-breadcrumb-item>
					
					}			
				</el-breadcrumb>
			]
			this.$slots.plug = [
				<statistics nodeid={this.nodeid} ref="statistics" onExportdetail={this.exportdetail} />,
				<roundIndex currentrow={this.currentrow} ref="roundIndex" onSubmit={this.roundSubmit} />,
				<reconciliation currentrow={this.currentrow} rows = {this.sourcedata} reconciliationtype={this.reconciliationtype} ref="reconciliation" onDrawerhide={this.draweronhide} />,
				<directlystockin ref="directlystockin"  />,
				<editIndex title="更换结算单" row={this.currentrow} onSuccess={this.editSuccess} ref="purchasestockbillEdit" />
			]			
			return listBase.render.call(this, h)
		},
		data() {
			return {
				defaulttime:this.$Moment().startOf('month').valueOf(),
				asideWidth: 150,
				moduleName: 'purchasestockbill',
				windowName: '采购入库单',
				windowType: 'modal',
				settlementtreeKey: Math.random(),
				nodeid: [],
				parentbread: [],
				currentrow: null,
				currentrcvinfo: null,
				currentpayinfo:null,
				mkcodetitle: '',
				currentRow:null,
				sourcedata:[],
				reconciliationtype:'single'
				
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {
			this.nodeid = [this.defaulttime]
			//this.foreingKey.settlementtype = '8805,8825'
		},
		computed: {

		},

		methods: {	
			newgoods(row){
				this.$confirm('是否确认设置为新品', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.loading = true
					this.$api.purchasestockbill.newgoods({
						stockCode:row.stockCode,
					}).then((res)=>{
						row.remark = res
						this.$message.success('提交成功')
						this.loading = false
					},()=>{
						this.loading = false
					})
				}).catch(() => {
					this.loading = false
				})
			},
			synchronous(row){
				this.loading = true
				this.$api.purchasestockbill.synchronous({
						billCode:row.billCode,
					}).then(()=>{
						this.$message.success('提交成功')
						this.loading = false
				},()=>{
					this.loading = false
				})
			},
			editformShow(row){
				console.log(row)
				this.currentrow = row
				this.$refs.purchasestockbillEdit.modalShow()
			},
			directlystockin(){
				this.$refs.directlystockin.modal_show()
			},
			settlement(row) {
				this.loading = true
				this.$api.purchasestockbill.getpaymentinfo({
						billCode:row.billCode,
						wlnid:row.supplierID,
					}).then((res)=>{
						this.currentrow = row
						row.available = res.available
						this.$refs.roundIndex.modal_show()
						this.loading = false
				},()=>{
					this.loading = false
				})						
			},
			settlementbatch(){
				let data = this.$refs[this.moduleName+'_list'].getCheckboxRecords()
				if(!data.length){
					this.$message.error('请选择数据')
					return
				}
				let useabledata = data.filter((item)=>{
					return item.amt == item.debt && item.paymentmethod == 8805
				})
				useabledata.forEach((item)=>{
					this.settlementbatchHandle(item)
				})
			},
			settlementbatchHandle(row){
				this.loading = true
				this.$api.purchasestockbill.getpaymentinfo({
						billCode:row.billCode,
						wlnid:row.supplierID,
					}).then((res)=>{
						if(res.available >= row.debt){
							let obj = {
								type: 6,
								wlnid: row.supplierID,
								purchasecode: row.billCode,
								stockCode:row.stockCode,
								bankAcc: row.bankAcc,
								round: 0,
								settlementamount: row.debt
							}
							this.roundSubmit(obj)
						}else{
							this.$message.error('【'+row.stockCode+'】结算金额大于【预付款余额】')
						}
						this.loading = false
				},()=>{
					this.loading = false
				})	
			},
			roundSubmit(e){
				let handle = this.$loading()
				this.$api.reconciliationcurrent.settlement(e).then(() => {
					this.$loadingclose(handle)
					this.$message.success('操作成功')
					this.customreload()				
				}, () => {
					this.$loadingclose(handle)
				})
				//console.log(e)
			},
			draweronhide(){
				this.sourcedata = []
				this.currentrow = null
			},
			reconciliationbatch(){
				this.sourcedata = this.$refs[this.moduleName+'_list'].getTableData().fullData
				this.reconciliationtype = 'batch'
				this.$nextTick(()=>{
					this.$refs.reconciliation.drawer_show()
				})
			},
			reconciliation(row){
				this.currentrow = row
				this.reconciliationtype = 'single'
				this.$nextTick(()=>{
					this.$refs.reconciliation.drawer_show()
				})
			},
			importpanel() {
				this.$refs[this.importRef].importcomfig = ()=>{
					let res = [{
						code: "stockCode",
						require: true,
						title: "单据编码",
						unique: false,
					},{
						code: "voucherno",
						require: false,
						title: "凭证号",
						unique: false,
					}]
					return Promise.resolve(res)
				}
				this.$refs[this.importRef].importpanel()	
			},
			statistics(){
				if(this.nodeid.length==0){
					this.$message.error('请选择时间')
					return
				}
				this.$refs.statistics.modalShow()
			},
			exportdetail(e){
				console.log(e)
				this.$refs[this.moduleName+'_list'].exportData({
					data:e.data,
					type: 'xlsx',
					remote:false
				})
			},
			cellClick(e) {
				if (e.column.field) {
					this.currentRow = e.row
				}
				
			},
			// cellClick({row,column}){
			// 	if(column.field==''){
					
			// 	}
			// 	console.log(row,column)
			// },
			beforeCreateGrid(formConfig,columns){
				columns.unshift({
						type: 'checkbox',
						title: '',
						field:'',
						fixed:'left',
						width:50
				})
				columns.forEach((item)=>{
					// if(item.field=='img_file'){
					// 	item.slots = {
					// 		default:({row})=>{
					// 			if(row.img_file){
					// 				row.img_file.forEach((item)=>{
					// 					let filetype = this.getFileType(item.name)
					// 					item.previewurl = (filetype === 'JPG' || filetype === 'PNG') ? item.path : require('@_system/icon/pdf.png')
					// 				})
					// 				return 	<el-image style="width: 30px; height: 30px" src={row.img_file[0].previewurl} preview-src-list={row.img_file.map((item)=>{
					// 					let filetype = this.getFileType(item.name)
									
					// 					return (filetype === 'JPG' || filetype === 'PNG') ? item.path : require('@_system/icon/pdf.png')
					// 				})}></el-image>
					// 			}else{
					// 				return ''
					// 			}
					// 		}
					// 	}
					// }
					if(item.field == 'haspaper'){
						item.align = 'center'
						item.cellRender = {
							name:'$switch',
							enabled:true,
							props:{
								openLabel:'有',
								closeLabel:'无',
								openValue:5,
								closeValue:6,
								size:'medium',
							},
							events:{
								change:({row})=>{
									this.haspaperChnage(row)
								}
							}
						}
					}
					if(item.field == 'signfor'){
						item.align = 'center'
						item.cellRender = {
							name:'$switch',
							enabled:true,
							props:{
								openLabel:'是',
								closeLabel:'否',
								openValue:5,
								closeValue:6,
								size:'medium',
							},
							events:{
								change:({row})=>{
									this.signforChnage(row)
								}
							}
						}
					}
					if(item.field=='export_jindie'){
						item.slots = {
							default:({row})=>{
								if(row.export_jindie){
									if(row.export_jindie_sucess == 1){
										return <span style="color:#67C23A;">已同步</span>
									}else{
										if(row.export_jindie_error){
											let error = row.export_jindie_error.map((item)=>{
												return item.Message
											})
											//console.log(row.export_jindie_error)
											return <span style="color:#F56C6C;">{error.join(',')}</span> 
										}else{
											return <span style="color:#F56C6C;">同步失败</span> 
							
										}									
									}
								}else{
									return '未同步'
								}
							}
						}
					}
				})
			},
			getFileType(url) {
				let filetype = url.split('.')
				filetype = filetype[filetype.length - 1]
				//console.log(filetype.toUpperCase())
				return filetype.toUpperCase()
			},
			haspaperChnage(row){
				this.$api.purchasestockbill.update(row.id,{haspaper:row.haspaper}).then(()=>{
					
				},()=>{
					row.haspaper = row.haspaper==5?6:5
				})
			},
			signforChnage(row){
				this.$api.purchasestockbill.update(row.id,{signfor:row.signfor}).then(()=>{
					
				},()=>{
					row.signfor = row.signfor==5?6:5
				})
			},
			settlementtreeChange(e) {
				this.parentbread = []
				this.nodeid = e.parentid != 0 ? [e.id] : e.childrenid
				if (e.parentid != 0) {
					this.parentbread.push({
						id: e.parentid,
						name: e.parentid
					})
				}
				this.parentbread.push({
					id: e.id,
					name: e.name
				})
				// this.gridOptions.pagerConfig = {
				// 	currentPage: 1,
				// 	pageSize: 20,
				// }
				this.customreload()
			},
			editSuccess(){
				this.customreload()
			},
			reject(row) {
				this.$prompt('请填写驳回原因', '驳回', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					inputPattern: /\S/,
					inputErrorMessage: '原因不能为空'
				}).then(({
					value
				}) => {
					this.$api.purchasestockbill.update(row.id,{reject:1,rejectcontent:value}).then(()=>{
						this.$message.success('操作成功')
					})
				}).catch(() => {

				})
			},
			urgent(row){
				this.$api.purchasestockbill.update(row.id,{voucherurgent:1}).then((res)=>{
					this.$message.success(res)
				})
	
			},
			beforeexport (obj,type) {
				return new Promise((resolve,reject)=>{
					if(type=='total'){
						if(this.nodeid.length==0){
							this.$message.error('请选择月份')
							reject()
						}else{
							obj.nodeid = this.nodeid
							resolve()
						}	
					}else{
						resolve()
					}

				})
			},
			beforeRequest(form) {
				form.nodeid = this.nodeid
			},
			
		},
		components: {
			
		}
	}
</script>